import { useMemo } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../../../components/common/icon/Icon';
import { IProductFilter } from '../../../../../../constants/product/productFilter.constant';
import { useGetFilterHasSelectedOption } from '../../../../../../hooks/filter/useGetFilterHasSelectedOption';

interface ProductFilterButtonProps {
  filter: IProductFilter;
  onClick: () => void;
}

export const ProductFilterButton = ({ filter, onClick }: ProductFilterButtonProps) => {
  const { isFilterHasSelectedOption } = useGetFilterHasSelectedOption({ filter });

  const filterTitle = useMemo<string>(() => {
    if (filter.optionType === 'radio') {
      const selectedOption = filter.options.find((option) => option.isSelected);

      if (selectedOption) {
        return selectedOption?.optionName;
      }
    } else if (filter.optionType === 'checkbox') {
      const selectedOptions = filter.options.filter((option) => option.isSelected === true);

      if (selectedOptions.length === 1) {
        return selectedOptions[0].optionName;
      }

      if (selectedOptions.length > 1) {
        return `${selectedOptions[0].optionName} 외 ${selectedOptions.length - 1}개`;
      }
    }

    return filter.title;
  }, [filter]);

  return (
    <Container isActive={isFilterHasSelectedOption} onClick={onClick}>
      <ButtonText isActive={isFilterHasSelectedOption}>{filterTitle}</ButtonText>
      {isFilterHasSelectedOption && <Icon name="ArrowDownBlue" width={10} height={10} />}
      {!isFilterHasSelectedOption && <Icon name="ArrowDown2" width={10} height={10} />}
    </Container>
  );
};

const Container = styled.button<{ isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px 16px;
  gap: 4px;

  border-radius: var(--radius-round, 80px);
  background: ${(props) => (props.isActive ? '#E5E9FF' : '#f2f2f7')};
`;

const ButtonText = styled.div<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? '#445EFF' : '#232429')};
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */

  white-space: nowrap;
`;
